// ABOUTME: Timesheet hours rules: Hourly is an hourly rate, Monthly is quantity 1.
// ABOUTME: Legacy Internal Only project name is non-billable; SOW assignees are excluded server-side.

export function isMonthlyProject(projectName) {
  return /\bmonthly\b/i.test(String(projectName || ''));
}

export function isHourlyProject(projectName) {
  return /\bhourly\b/i.test(String(projectName || ''));
}

export function isInternalOnlyProject(projectName) {
  return /^\s*internal\s+only\s*$/i.test(String(projectName || ''));
}

export function defaultHoursForProject(projectName, hoursWorked) {
  if (isMonthlyProject(projectName)) {
    return 1;
  }
  if (hoursWorked == null || hoursWorked === '') {
    return 0;
  }
  const n = Math.round(Number(hoursWorked));
  return Number.isFinite(n) ? n : 0;
}
